<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useFreshDesk } from './composables/useFreshDesk'
import useThemes from './composables/useThemes'
import { useAuthService } from './auth/AuthService'

export default defineComponent({
  name: 'App',
  setup() {
    const { hideLauncher } = useFreshDesk()
    const { init } = useThemes()
    init()
    hideLauncher()

    const authService = useAuthService()

    onMounted(async () => {
      await authService.clearStaleStateAsync()
    })

    return {}
  },
})
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
